import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { EditOutlined, NotInterestedOutlined, PersonOutlined } from "sprout-ui-icons";
import { Box, Text } from "sprout-ui-primitives";
import { Select } from "../Form";
export var SelectJoinAsValue;
(function(SelectJoinAsValue) {
    SelectJoinAsValue["ADMIN"] = "ADMIN";
    SelectJoinAsValue["CONTRIBUTOR"] = "CONTRIBUTOR";
    SelectJoinAsValue["DISABLED"] = "DISABLED";
})(SelectJoinAsValue || (SelectJoinAsValue = {}));
const options = [
    {
        value: SelectJoinAsValue.ADMIN,
        label: "Editor - do (almost) everything",
        description: "Can organize and edit all leaves",
        icon: EditOutlined
    },
    {
        value: SelectJoinAsValue.CONTRIBUTOR,
        label: "Member - add leaves and comment",
        description: "Can add leaves and comment",
        icon: PersonOutlined
    },
    {
        value: SelectJoinAsValue.DISABLED,
        label: "Disabled - cannot self join",
        description: "Must be invited to join this tree",
        icon: NotInterestedOutlined
    }, 
];
const SelectJoinAs = (props)=>{
    const { value , onChange  } = props;
    const handleChange = useCallback((nextValue)=>{
        onChange(nextValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(Select, {
                value: value,
                label: "Workspace members can self join tree as",
                options: options,
                onChange: handleChange
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "15px",
                color: "black.60",
                mt: "8px",
                lineHeight: "21px",
                children: "Gives workspace members the permission to join the tree without sending them an invite. Choose what permission they have when they self join."
            })
        ]
    });
};
export default SelectJoinAs;
